import { useEffect, useState } from 'react'

type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
  isExpired: boolean
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

export function useCountdown(durationInSeconds: number): TimeLeft {
  const [remaining, setRemaining] = useState(durationInSeconds)

  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining((current) => (current <= 0 ? 0 : current - 1))
    }, 1000)

    return () => window.clearInterval(interval)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
    isExpired: remaining <= 0,
  }
}
